import { BusinessProfileResponse } from "../contracts/BusinessProfileResponse";
import { BusinessProfile } from "../models/BusinessProfile";

export const mapResponseToBusinessProfile = (resp: BusinessProfileResponse): BusinessProfile => ({
  businessName: resp.businessName,
  address: resp.address,
  taxId: resp.taxId,
  iban: resp.iban,
  defaultFooterNote: resp.defaultFooterNote,
  nextInvoiceNumber: resp.nextInvoiceNumber,
});
